import { useEffect, useRef, useState } from 'react';
import { Formik, Form, Field, FieldArray, ErrorMessage, useFormikContext } from 'formik';
import { KeenIcon, DefaultTooltip, LazyFormikSelect, DatePicker, CustomOption, CustomSingleValue } from '@/components';
import { useLazyOptions } from '@/hooks';
import { toast } from 'sonner';
import expenseService from '@/services/billing/expenses/expenseService';
import userService from '@/services/setting/userService';
import taxService from '@/services/billing/taxService';
import { calculateSubtotal } from '@/utils';
import invoiceService from '@/services/billing/invoice/invoiceService';
import { PriceInput } from '@/components/form';
import categoryService from '@/services/billing/expenses/categoryService';
import { CategoryModal } from '@/pages/billing';
import { useAbility } from '@/providers/';
import { Can } from '@casl/react';
import { useUserOptions, useTaxOptions, useExpenseCategoryOptions } from '@/hooks'

const Expense = ({ openModal, loadOnChange }) => {
    const { values, setFieldValue } = useFormikContext();
    const [dataLoading, setDataLoading] = useState(false);
    const [userData, setuserData] = useState([]);
    const [itemData, setItemData] = useState([])
    const expenseSettings = values.template_Settings?.expenses
    const formikRef = useRef();
    const [open, setOpen] = useState(false);
    const [mode, setMode] = useState('create');
    const [selectedData, setSelectedData] = useState(null);
    const [taxesData, setTaxesData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [loading, setLoading] = useState(false)
    const { ability } = useAbility();
    const [itemId, setItemId] = useState(null)
    const loadUserOptions = useUserOptions({ defaultPageSize: 20 });
    const loadTaxOptions = useTaxOptions({ defaultPageSize: 20 });
    const loadExpenseCategoryOptions = useExpenseCategoryOptions({ defaultPageSize: 20 });


    // useEffect(() => {
    //     resetCategories()
    // }, [loadOnChange])


    const getSingleExpense = async (expenseId) => {
        setDataLoading(true)
        try {
            const { data, status } = await expenseService.getSingleExpense(expenseId);
            if (status) {
                setExpenseData(data)
            }
        } catch (error) {
            console.error('Error', error)
            toast.error('Failed to fetch Contact.', {
                description: 'An error occurred while fetching contact. Please try again later.',
            });
        } finally {
            setDataLoading(false)
        }
    }

    return (
        <>
            <div className='flex items-center my-5'>
                <span className='w-1/2 h-0.5 border border-dashed inline-block'></span>
                <p className='text-sm px-4'>Expenses</p>
                <span className='w-1/2 h-0.5 border border-dashed inline-block'></span>
            </div>
            <div>
                <FieldArray name="expenses" className="card">
                    {({ push, remove }) => (
                        <>
                            {values.expenses.map((_, index) => (
                                <div key={index} className=''>
                                    <div className='flex items-center justify-between mb-3'>
                                        <div className='flex items-center'>
                                            <span className='w-12 h-0.5 bg-border inline-block mr-2'></span>
                                            <h4 className='text-sm'>Expense #{index + 1}</h4>
                                        </div>
                                        <div className='flex items-center gap-1.5'>
                                            {/* {index === 0 && values.expenses.length < 10 && (
                                        <>
                                        <button type="button" className='text-xs btn btn-sm btn-light' onClick={() => push({
                                            category_id: '',
                                            expense: null,
                                            description: '',
                                            billed_by: '',
                                            billed_by_user: null,
                                            quantity: 1,
                                            rate: '',
                                            date: new Date().toISOString().split('T')[0],
                                            tax: [],
                                        })}>
                                            <KeenIcon icon="plus" />
                                            Add Expense
                                        </button>
                                        </>
                                    )} */}
                                            <button type="button" className='btn btn-sm btn-danger btn-outline my-2' onClick={() => remove(index)}>
                                                <KeenIcon icon="trash" />
                                                Remove
                                            </button>
                                            {/* {values.expenses.length > 1 && (
                                    )} */}
                                        </div>
                                    </div>

                                    <div className="rounded-md p-1.5 flex flex-nowrap">
                                        <div className='invoice-select-w'>
                                            <label className="form-label mb-1.5 pl-1.5">{expenseSettings?.expenses_label || 'Expense Category'} </label>
                                            <LazyFormikSelect
                                                name={`expenses[${index}].category_id`}
                                                loadOptions={loadExpenseCategoryOptions}
                                                pageSize={20}
                                                preloadedOption={values.expenses[index].expense}
                                                transparent={true}
                                                noOptionsMessage={() => (
                                                    isLoading ? (
                                                        <span className="text-sm">Loading...</span>
                                                    ) : (
                                                        <div>
                                                            <span className="text-sm mr-1">No options available</span>
                                                            <Can I='create' a='item' ability={ability}>
                                                                <button type="button"
                                                                    onClick={openModal}
                                                                    className="link block mx-auto"
                                                                >
                                                                    Add new
                                                                </button>
                                                            </Can>
                                                        </div>
                                                    )
                                                )}
                                            />
                                            <ErrorMessage
                                                name={`expenses[${index}].category_id`}
                                                component="div"
                                                className="text-red-500 text-[11px] mt-1"
                                            />
                                        </div>
                                        {/* <div className='invoice-date-w'>
                                    <DefaultTooltip title={
                                        <>
                                            <div>
                                                <span>Soft Cost:</span> <br />
                                                <span className='font-thin'>
                                                    Intangible expenses for your clients (travel costs, envelopes, faxes, etc…)
                                                </span>
                                            </div>
                                            <br />
                                            <div>
                                                <span>Hard Cost:</span> <br />
                                                <span className='font-thin'>
                                                    Expenses you need to pay a third-party vendor for (court filing fees, private investigators, mediators, etc...)
                                                </span>
                                            </div>
                                        </>
                                    }>
                                        <label className="form-label mb-1.5 items-center gap-1">
                                            <KeenIcon icon="information" />
                                            Cost Type
                                        </label>
                                    </DefaultTooltip>
                                    <Field as="select" className="input transparent-input" name={`expenses[${index}].cost_type`}>
                                        <option value="soft cost">Soft Cost</option>
                                        <option value="hard cost">Hard Cost</option>
                                    </Field>
                                </div> */}
                                        <div className='invoice-date-w'>
                                            <label className="form-label mb-1.5 pl-1.5">{expenseSettings?.date_label || 'Date'}</label>
                                            <Field name={`expenses[${index}].date`} component={DatePicker} isRange={false} transparent={true} />
                                            <ErrorMessage
                                                name={`expenses[${index}].date`}
                                                component="div"
                                                className="text-red-500 text-[11px] mt-1"
                                            />
                                        </div>
                                        <div className='invoice-date-w'>
                                            <label className="form-label mb-1.5 pl-1.5">To</label>
                                            <Field name={`expenses[${index}].date_to`} component={DatePicker} isRange={false} transparent={true} />
                                            <ErrorMessage name={`expenses[${index}].date_to`} component="div" className="text-red-500 text-[11px] mt-1" />
                                        </div>
                                        <div className='invoice-select-w'>
                                            <label className="form-label mb-1.5 pl-1.5">{expenseSettings?.billed_by_label || 'Billed By'}</label>
                                            <LazyFormikSelect
                                                name={`expenses[${index}].billed_by`}
                                                loadOptions={loadUserOptions}
                                                pageSize={20}
                                                preloadedOption={values.expenses[index].billed_by_user}
                                                transparent={true}
                                                components={{
                                                    Option: CustomOption,
                                                    SingleValue: CustomSingleValue,
                                                }}
                                            // customClassNames={{
                                            //     menuList: '!max-h-[120px]',
                                            // }}
                                            />
                                            <ErrorMessage
                                                name={`expenses[${index}].billed_by`}
                                                component="div"
                                                className="text-red-500 text-[11px] mt-1"
                                            />
                                        </div>
                                        <div className='invoice-price-w'>
                                            <label className="form-label mb-1.5 pl-1.5">{expenseSettings?.quantity_label || 'Quantity'}</label>
                                            {/* <Field className="input transparent-input no-spinner" type="number" name={`expenses[${index}].quantity`} /> */}
                                            <Field name={`expenses[${index}].quantity`}>
                                                {({ field, form }) => (
                                                    <input
                                                        {...field}
                                                        type="number"
                                                        className="input transparent-input no-spinner"
                                                        step={'1'}
                                                        min="0"
                                                        inputMode={'numeric'}
                                                        onChange={(e) => {
                                                            let value = e.target.value;
                                                            value = value.replace(/\D/g, '');
                                                            value = value.replace(/^0+(?!$)/, '');
                                                            form.setFieldValue(`expenses[${index}].quantity`, value);
                                                        }}
                                                    />
                                                )}
                                            </Field>
                                            <ErrorMessage
                                                name={`expenses[${index}].quantity`}
                                                component="div"
                                                className="text-red-500 text-[11px] mt-1"
                                            />
                                        </div>
                                        <div className='invoice-rate-w shrink-0 overflow-x-hidden'>
                                            <label className="form-label mb-1.5 pl-1.5">{expenseSettings?.price_label || 'Price'}</label>
                                            <PriceInput name={`expenses[${index}].rate`} prefix="$" className="transparent-input" />
                                        </div>
                                        <div className='invoice-rate-w'>
                                            <label className="form-label mb-1.5 pl-1.5">{expenseSettings?.subtotal_label || 'Sub'}</label>
                                            <div className='input transparent-input'>
                                                {calculateSubtotal(values.expenses[index].rate, values.expenses[index].quantity)}
                                            </div>
                                        </div>
                                        <div className='invoice-tax-w !w-[230px]'>
                                            <label className="form-label mb-1.5 pl-1.5">{expenseSettings?.tax_label || 'Tax'}</label>
                                            <LazyFormikSelect
                                                name={`expenses[${index}].tax`}
                                                isMulti={true}
                                                loadOptions={loadTaxOptions}
                                                pageSize={20}
                                                preloadedOption={values.expenses[index].taxes?.length > 0 ? values.expenses[index].taxes : []}
                                                transparent={true}
                                                returnFullObject
                                            />
                                            <ErrorMessage
                                                name={`expenses[${index}].tax`}
                                                component="div"
                                                className="text-red-500 text-[11px] mt-1"
                                            />
                                        </div>
                                        {/* <div className='invoice-tax-w !w-[165px]'>
                                    <label className="form-label mb-1.5 pl-1.5">{expenseSettings?.tax2_label || 'Tax 2'}</label>
                                    <LazyFormikSelect
                                        name={`expenses[${index}].tax2`}
                                        options={taxOptions}
                                        onFocus={() => loadTax(null)}
                                        isLoading={taxLoading}
                                        preloadedOption={values.expenses[index].tax2}
                                        transparent={true}
                                        returnFullObject
                                    />
                                    <ErrorMessage
                                        name={`expenses[${index}].tax2`}
                                        component="div"
                                        className="text-red-500 text-[11px] mt-1"
                                    />
                                </div> */}
                                        <div>
                                            <label className="form-label mb-1.5 pl-1.5">{expenseSettings?.description_label || 'Description'}</label>
                                            <Field as="textarea" className="input transparent-input pt-2 overflow-auto custom-scrollbar" name={`expenses[${index}].description`} />
                                            <ErrorMessage
                                                name={`expenses[${index}].description`}
                                                component="div"
                                                className="text-red-500 text-[11px] mt-1"
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {/* No row limit (OL-200). The button sits under the last row, so a new row opens where the user is. */}
                            <div className='flex items-center justify-end'>
                                <button type="button" className='text-xs btn btn-sm btn-light' onClick={() => push({
                                    category_id: '',
                                    expense: null,
                                    description: '',
                                    billed_by: '',
                                    billed_by_user: null,
                                    quantity: null,
                                    rate: '',
                                    date: '', //new Date().toISOString().split('T')[0]
                                    tax: [],
                                })}>
                                    <KeenIcon icon="plus" />
                                    Add Expense
                                </button>
                            </div>
                        </>
                    )}
                </FieldArray>
            </div>
        </>
    )
}

export { Expense }